import React from 'react';
import HideableSection from 'react-scale/corp/components/UI/HideableSection';
import { ReactJsonView } from 'react-scale/corp/components/ReactJsonView';
import { ISensorFusionSubstageInstanceLookupDto } from '@scale/sensor-fusion-shared';
import { openSelectedIfUrl } from '../helpers/url';

type SubstageInstanceJSONPanelProps = {
  substageInstance: ISensorFusionSubstageInstanceLookupDto;
};

const SubstageInstanceJSONPanel = ({ substageInstance }: SubstageInstanceJSONPanelProps) => {
  return (
    <HideableSection name="Substage Instance JSON">
      <ReactJsonView
        src={substageInstance}
        name={false}
        theme="monokai"
        iconStyle="triangle"
        collapsed={1}
        onSelect={openSelectedIfUrl}
        collapseStringsAfterLength={120}
        groupArraysAfterLength={false}
        enableClipboard={true}
        displayObjectSize={false}
        displayDataTypes={false}
      />
    </HideableSection>
  );
};

export default SubstageInstanceJSONPanel;
